import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AlertifyService } from 'src/app/services/alertify.service';
import { ExtencionService } from 'src/app/services/extencion.service';

import {
  MomentDateAdapter,
  MAT_MOMENT_DATE_ADAPTER_OPTIONS,
} from '@angular/material-moment-adapter';
import {
  DateAdapter,
  MAT_DATE_FORMATS,
  MAT_DATE_LOCALE,
} from '@angular/material/core';
import { MatDatepicker } from '@angular/material/datepicker';

import * as _moment from 'moment';
import { default as _rollupMoment, Moment } from 'moment';
const moment = _rollupMoment || _moment;

export const MY_FORMATS = {
  parse: {
    dateInput: 'DD/MM/YYYY',
  },
  display: {
    dateInput: 'DD/MM/YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};

@Component({
  selector: 'app-add-extencion',
  templateUrl: './add-extencion.component.html',
  styleUrls: ['./add-extencion.component.scss'],
  providers: [{ provide: MAT_DATE_FORMATS, useValue: MY_FORMATS }],
})
export class AddExtencionComponent implements OnInit {
  registerForm: UntypedFormGroup;

  constructor(
    private alertify: AlertifyService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<AddExtencionComponent>,
    private extencionesSvc: ExtencionService
  ) {}

  ngOnInit(): void {
    this.inicarFormulario();
  }

  inicarFormulario() {
    this.registerForm = new UntypedFormGroup({
      usuarioId: new UntypedFormControl('', Validators.required),
      fechaNueva: new UntypedFormControl('', Validators.required),
      comentario: new UntypedFormControl(''),
    });

    //'2023-03-01T23:59:59'
    //'yyyy-mm-dd'
    var dateParts = this.data.fechaIngresoHasta.split('T')[0].split('/');
    var date = new Date(+dateParts[0], dateParts[1] - 1, +dateParts[2]);

    this.registerForm.get('usuarioId')?.setValue(this.data.id);

    this.registerForm
      .get('fechaNueva')
      ?.setValue(this.getFormatoFecha(this.data.fechaIngresoHasta));
  }

  private getFormatoFecha(fecha: any): string {
    var d = new Date(fecha),
      month = '' + (d.getMonth() + 1),
      day = '' + d.getDate(),
      year = d.getFullYear();

    if (month.length < 2) month = '0' + month;
    if (day.length < 2) day = '0' + day;

    return [year, month, day].join('-');
  }

  guardar() {
    console.log('guardar cambios disciplina');
    console.log(this.registerForm.value);

    this.extencionesSvc
      .addExtencionServicio(this.registerForm.value)
      .subscribe((res) => {
        console.log('resulo extender servicio: ', res);
        if (res) {
          this.alertify.success(
            'Extención del servicio actualizado'
          );
          this.dialogRef.close(true);
        } else {
          this.alertify.error(
            'La extención del servicio no se ha podido actualizar'
          );
        }
      });
  }
}
